exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea-authoheight {\n  transition: height 200ms;\n  overflow: hidden;\n  resize: none;\n}\n#taHiddenDiv {\n  display: block;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  position: absolute;\n  visibility: hidden;\n  max-width: calc(800px - 30px);\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  font-size: 16px;\n  padding: 15px;\n  font-family: HankenGroteskRegular, HankenGroteskRegularOld, HelveticaNeue, Helvetica, Arial, sans-serif;\n  margin-bottom: 40px;\n  line-height: 1.5;\n  top: -10000px;\n  left: -10000px;\n}\n.text {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}", ""]);

// exports
